export default __webpack_public_path__ + "static/media/science.fe6f5eed5db1d126c6003a94c3f94da5.svg";